document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-vd-tabs] .vd-tabs__btn');
  if (!btn) return;

  const root = btn.closest('[data-vd-tabs]');
  const tab = btn.getAttribute('data-tab');

  root.querySelectorAll('.vd-tabs__btn').forEach(b => {
    const active = b === btn;
    b.classList.toggle('is-active', active);
    b.setAttribute('aria-selected', active ? 'true' : 'false');
  });

  root.querySelectorAll('.vd-tabs__pane').forEach(pane => {
    const active = pane.getAttribute('data-pane') === tab;
    pane.classList.toggle('is-active', active);
    pane.hidden = !active;
  });
});
